import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CandidatureFormation} from '../candidature-formation.model';
import {Response} from '@angular/http';
import {CONSTANTS} from '../../../cadens.constants';
import {Formation, FormationService} from '../../formation';
import {ListeChoixService} from '../../../shared/ListeChoix/listeChoix.service';
import {ListeChoix} from '../../../shared/ListeChoix/listeChoix.model';

@Component({
    selector: 'jhi-avis-component',
    templateUrl: './avis.component.html'
})
export class AvisComponent implements OnInit {

    @Input() candidatureFormation: CandidatureFormation = {};
    @Input() avisEnabled: number;
    @Input() dateLimiteAvis: number ;
    @Output() candidatureFormationChange: EventEmitter<CandidatureFormation> = new EventEmitter();
    listeCommentaires: ListeChoix[];
    listeAvis: string[];
    constants = CONSTANTS;

    constructor(private listeChoixService: ListeChoixService,
                private formationService: FormationService) {
    }

    ngOnInit() {
        this.listeChoixService.query({type: CONSTANTS.AVIS}).subscribe(
            (res: Response) => {
                this.listeAvis = res.json().map(avis => avis.code);
                if (this.candidatureFormation.formationId != null) {
                    this.formationService.findPourEtudiant(
                        this.candidatureFormation.formationId, this.candidatureFormation.userId).subscribe(
                        (formation: Formation) => {
                            if (!formation.lc) {
                                this.listeAvis.pop();
                            }
                        });
                }
            });
        this.listeChoixService.query({type: CONSTANTS.COMMENTAIRE}).subscribe(
            (res: Response) => {
                this.listeCommentaires = res.json();
            });
    }

    chooseAvis(avis) {
        this.candidatureFormation.avis = this.candidatureFormation.avis === avis ? null : avis;
        this.candidatureFormation.avisRang = avis !== CONSTANTS.AWAITING ? null : this.candidatureFormation.avisRang;
        this.candidatureFormation.commentaire = avis !== CONSTANTS.NOTFAVORABLE ? null : this.candidatureFormation.commentaire;
        this.candidatureFormationChange.emit(this.candidatureFormation);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/avis/avis.component.ts